import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
import { canUseWebP, imageIsExist } from 'fe-common'

let defaultImagePath = `https://ik.imagekit.io/1pzxddx3qqv/Z54IV3/static/${
  process.env.TEMPLATE_ID
}/${process.env.COMP_ID}/game-default.png`

if (['tgb'].includes(process.env.COMP_ID)) {
  defaultImagePath = `https://ik.imagekit.io/1pzxddx3qqv/${
    process.env.COMP_ID
  }/img/game_gamedisabled.png`
}

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: defaultImagePath,
  loading: defaultImagePath,
  attempt: 1,
  filter: {
    async webp(listener, options) {
      // eslint-disable-next-line no-constant-condition
      if (true || !options.supportWebp) return // // todo: if all lazy image's src to webp, please remove 'true ||' code.
      const optimizeImageUrl =
        listener.src
          .split('.')
          .slice(0, -1)
          .join('.') + '.webp'
      let exist = false
      if (canUseWebP()) {
        exist = await imageIsExist(optimizeImageUrl)
      }
      if (exist) {
        listener.src = optimizeImageUrl
      }
    }
  }
})
